import React from "react";
import { useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import SiglasImg from '../../assets/images/siglas.png';
import Onu from "./components/Onu";
import Lan from "./components/Lan";
import Wan from "./components/Wan";

import "font-awesome/css/font-awesome.min.css";
import './styles.css';
import Ont from "./components/Ont";

const Siglas = () => {

    const [show, setShow] = useState(false);
    const [show1, setShow1] = useState(false);
    const [show2, setShow2] = useState(false);
    const [show3, setShow3] = useState(false);

    const handleClose = () => setShow(false);
    const handleClose1 = () => setShow1(false);
    const handleClose2 = () => setShow2(false);
    const handleClose3 = () => setShow3(false);

    const handleShow = () => setShow(true);
    const handleShow1 = () => setShow1(true);
    const handleShow2 = () => setShow2(true);
    const handleShow3 = () => setShow3(true);

    return (
        <div className="container">
            <div className="row">
                <div className="siglas-title">
                    <h1>Siglas e Significados</h1>
                </div>
                <div className="col-sm-12 col-md-4">
                    <div className="siglas">
                        <img src={SiglasImg} alt="siglas" />
                    </div>
                </div>
                <div className="col-sm-12 col-md-8">
                    <div className="siglas">
                        <h4>Categoria de Rede e Internet</h4>
                        <Accordion>
                            <Accordion.Item eventKey="12">
                                <Accordion.Header>LAN - (Local Area Network) ou siplismente Rede Local: </Accordion.Header>
                                <Accordion.Body>
                                    é uma rede de computadores que abrange uma área geográfica limitada, geralmente dentro de um
                                    único edifício ou campus. Ela permite a comunicação e o compartilhamento de recursos entre dispositivos,
                                    como computadores, impressoras, dispositivos de armazenamento e outros dispositivos de rede. As LANs são
                                    frequentemente utilizadas em ambientes corporativos, educacionais e residenciais para facilitar o
                                    compartilhamento de informações e o acesso à Internet.
                                    Elas são geralmente configuradas com tecnologias como Ethernet, Wi-Fi e protocolos de comunicação TCP/IP.
                                    <hr />
                                    <Button
                                        variant="outline-primary"
                                        className="mr-sm-2 custom-margin-button"
                                        onClick={handleShow2}
                                    >
                                        <i class="fa fa-file-image-o" aria-hidden="true"></i>
                                    </Button>
                                    <Modal show={show2} onHide={handleClose2}>
                                        <Modal.Header closeButton>
                                            <Modal.Title>LAN (Local Area Network)</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body><Lan /></Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="secondary" onClick={handleClose2}>
                                                Close
                                            </Button>
                                        </Modal.Footer>
                                    </Modal>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="13">
                                <Accordion.Header>WAN - Wide Area Network (Rede de Longa Distância): </Accordion.Header>
                                <Accordion.Body>
                                    refere-se a uma rede de comunicação que cobre uma ampla área geográfica, como cidades, estados ou até
                                    países. Diferente das LANs (Local Area Networks) que conectam dispositivos em proximidades mais curtas,
                                    como em um escritório ou residência, as WANs utilizam tecnologias de telecomunicações para conectar
                                    dispositivos dispersos geograficamente, permitindo a comunicação e o compartilhamento de dados entre
                                    diferentes localizações. As WANs são essenciais para operações empresariais e governamentais,
                                    possibilitando a conexão de redes menores e o acesso à internet em larga escala, além de serem
                                    fundamentais para a infraestrutura global de comunicações.
                                    <hr />
                                    <Button
                                        variant="outline-primary"
                                        className="mr-sm-2 custom-margin-button"
                                        onClick={handleShow3}
                                    >
                                        <i class="fa fa-file-image-o" aria-hidden="true"></i>
                                    </Button>
                                    <Modal show={show3} onHide={handleClose3}>
                                        <Modal.Header closeButton>
                                            <Modal.Title>WAN - Wide Area Network</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body><Wan /></Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="secondary" onClick={handleClose3}>
                                                Close
                                            </Button>
                                        </Modal.Footer>
                                    </Modal>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </div>
                </div>

                <div className="col-sm-12 col-md-4">
                    <div className="siglas">
                        <img src={SiglasImg} alt="siglas" />
                    </div>
                </div>
                <div className="col-sm-12 col-md-8">
                    <div className="siglas">
                        <h4>Categoria de Internet de Fibra</h4>
                        <Accordion>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>ONU (Optical Network Unit): </Accordion.Header>
                                <Accordion.Body>
                                    A ONU (Unidade de Fibra Óptica) é um equipamento que recebe o sinal da internet do provedor (via OLT -{'>'} Spliter)
                                    e o transforma em impulsos elétricos. Esse aparelho fica localizado dentro da casa do cliente e
                                    converte os sinais ópticos em sinais elétricos que podem ser usados pelos dispositivos do cliente.
                                    A ONU é frequentemente chamada de 'modem' pelas pessoas, pois desempenha um
                                    papel semelhante, conectando sua casa à Internet de alta velocidade por meio da fibra óptica.
                                    A maioria das ONUs funcionam em modo bridge havendo a necessidade de instalar um roteador para autenticação via PPPoE
                                    e realizar a distribuição da internet por cabos de rede ou sinal Wi-Fi
                                    <hr />
                                    <Button
                                        variant="outline-primary"
                                        className="mr-sm-2 custom-margin-button"
                                        onClick={handleShow}
                                    >
                                        <i class="fa fa-file-image-o" aria-hidden="true"></i>
                                    </Button>
                                    <Modal show={show} onHide={handleClose}>
                                        <Modal.Header closeButton>
                                            <Modal.Title>ONU (Optical Network Unit)</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body><Onu /></Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="secondary" onClick={handleClose}>
                                                Close
                                            </Button>
                                        </Modal.Footer>
                                    </Modal>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>ONT (Optical Network Terminal): </Accordion.Header>
                                <Accordion.Body>
                                    A ONT é um dispositivo que se conecta à infraestrutura de fibra óptica da operadora e
                                    converte os sinais ópticos em sinais elétricos que podem ser usados pelos dispositivos do cliente.
                                    A ONT também é chamada de 'modem', por desempenha um papel semelhante, conectando sua casa
                                    à Internet de alta velocidade, TV por assinatura, Wi-Fi e outros serviços por meio da fibra óptica.
                                    <hr />
                                    <Button
                                        variant="outline-primary"
                                        className="mr-sm-2 custom-margin-button"
                                        onClick={handleShow1}
                                    >
                                        <i class="fa fa-file-image-o" aria-hidden="true"></i>
                                    </Button>
                                    <Modal show={show1} onHide={handleClose1}>
                                        <Modal.Header closeButton>
                                            <Modal.Title>ONT (Optical Network Unit)</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body><Ont /></Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="secondary" onClick={handleClose1}>
                                                Close
                                            </Button>
                                        </Modal.Footer>
                                    </Modal>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>CPE (Customer Premises Equipment): </Accordion.Header>
                                <Accordion.Body>
                                    O CPE é um termo genérico usado para se referir a todos os equipamentos e dispositivos que estão
                                    localizados nas instalações do cliente e são usados para se conectar à rede da operadora.
                                    Isso pode incluir modems, roteadores, ONUs e outros dispositivos.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header>OLT (Optical Line Terminal): </Accordion.Header>
                                <Accordion.Body>
                                    A OLT é um componente central em redes PON/GPON/XGPON de fibra óptica. Ela é responsável por agregar o tráfego
                                    de várias ONUs e encaminhá-lo para a rede principal da operadora.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="4">
                                <Accordion.Header>PON (Passive Optical Network): </Accordion.Header>
                                <Accordion.Body>
                                    PON é uma arquitetura de rede de fibra óptica que usa componentes passivos, como divisores ópticos,
                                    para fornecer serviços de Internet,
                                    voz e vídeo a partir de uma única fibra óptica compartilhada.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="5">
                                <Accordion.Header>GPON (Gigabit Passive Optical Network):</Accordion.Header>
                                <Accordion.Body>
                                    GPON é uma variação da tecnologia PON que oferece maior largura de banda e velocidade, permitindo
                                    serviços de alta velocidade, como banda larga ultrarrápida e TV a cabo.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="6">
                                <Accordion.Header>XGPON (10-Gigabit Passive Optical Network):</Accordion.Header>
                                <Accordion.Body>
                                    XGPON é uma evolução da tecnologia GPON, fornecendo velocidades de até 10 gigabits por segundo (Gbps)
                                    para clientes, adequado para aplicações de alta demanda de largura de banda.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="7">
                                <Accordion.Header>DWDM (Dense Wavelength Division Multiplexing):</Accordion.Header>
                                <Accordion.Body>
                                    DWDM é uma tecnologia avançada de transmissão óptica utilizada em redes de fibra óptica para aumentar
                                    significativamente a capacidade de transmissão de dados. Essa tecnologia permite transmitir múltiplos
                                    sinais ópticos em diferentes comprimentos de onda (cores) em uma única fibra óptica.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="8">
                                <Accordion.Header>OTDR (Optical Time Domain Reflectometry):</Accordion.Header>
                                <Accordion.Body>
                                    O OTDR mede o tempo que leva para um sinal de luz para percorrer uma linha de
                                    transmissão e ser refletido de volta por uma descontinuidade na linha. Analisando o
                                    tempo de retorno do sinal refletido, o OTDR pode calcular a distância até a descontinuidade.
                                    É uma ferramenta essensial para encontrar rapidamente o local do rompimento da fibra.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="9">
                                <Accordion.Header>Power Meter (Medidor de Potência):</Accordion.Header>
                                <Accordion.Body>
                                    Medidor que calcula a potência e a perda relativa do sinal da fibra óptica, tanto ponto-a-ponto
                                    quanto ponto-multiponto, para indicar a qualidade da
                                    conexão do provedor de serviço de internet (Internet Service Provider – ISP).
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="10">
                                <Accordion.Header>ISP (Internet Service Provider):</Accordion.Header>
                                <Accordion.Body>
                                    Um Provedor de Serviço de Internet (ISP), abreviação para Internet Service Provider, refere-se
                                    a uma entidade que oferece uma variedade de serviços para facilitar o acesso, participação e
                                    conexão à internet. Essas organizações desempenham um papel fundamental na disponibilização de
                                    serviços online para usuários individuais e empresas, possibilitando a comunicação,
                                    o acesso a recursos digitais e a participação na rede global.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="11">
                                <Accordion.Header>WISP (Wireless Internet Service Provider):</Accordion.Header>
                                <Accordion.Body>
                                    Um WISP (Provedor de Serviços de Internet Sem Fio) é uma empresa que oferece acesso à Internet por
                                    meio de tecnologias sem fio, como rádio frequência e Wi-Fi. Eles instalam equipamentos de transmissão
                                    em locais estratégicos para enviar sinais de Internet para áreas específicas, permitindo que os clientes
                                    se conectem usando dispositivos sem fio. WISPs são cruciais em áreas rurais ou remotas onde a infraestrutura
                                    de comunicação com fio é limitada, fornecendo conectividade vital para comunidades e indivíduos.
                                    No entanto, eles enfrentam desafios como interferência de sinais e garantia de qualidade do serviço.
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </div>
                </div>
            </div>
            <br />
            <div className="row">
                <div className="siglas-title">
                    <h1>Siglas e Significados</h1>
                </div>
                <div className="col-sm-12 col-md-4">
                    <div className="siglas">
                        <img src={SiglasImg} alt="siglas" />
                    </div>
                </div>
                <div className="col-sm-12 col-md-8">
                    <div className="siglas">
                        <h4>Categoria de Telefonia SIP/VoIP</h4>
                        <Accordion>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>SIP - Session Initiation Protocol (Protocolo de Iniciação de Sessão): </Accordion.Header>
                                <Accordion.Body>
                                    É um protocolo de comunicação usado para iniciar, gerenciar e encerrar sessões de comunicação multimídia,
                                    como chamadas de voz e vídeo, pela Internet.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>VoIP - Voice over Internet Protocol (Voz sobre Protocolo de Internet): </Accordion.Header>
                                <Accordion.Body>
                                    É uma tecnologia que permite a transmissão de voz em tempo real pela Internet ou por redes IP.
                                    Ela converte sinais de áudio analógicos em dados digitais que podem ser transmitidos pela Internet,
                                    oferecendo uma alternativa mais econômica e flexível às tradicionais linhas telefônicas.
                                    <br /><br />
                                    Juntas, SIP e VoIP revolucionaram a comunicação, permitindo chamadas telefônicas pela Internet e
                                    fornecendo uma base para uma ampla gama de serviços
                                    de comunicação baseados em IP, como videoconferência, mensagens instantâneas e telefonia empresarial.
                                    <br /><br />
                                    Abaixo exemplos de equipamentos utilizados por essas tecnologias:
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>ATA - Analog Telephone Adapter (Adaptador de Telefone Analógico): </Accordion.Header>
                                <Accordion.Body>
                                    É um dispositivo que permite que telefones analógicos tradicionais sejam conectados a uma rede VoIP.
                                    Ele converte sinais de voz analógicos em dados digitais que podem ser transmitidos pela Internet.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header>IP Phones - Telefones IP: </Accordion.Header>
                                <Accordion.Body>
                                    São telefones projetados especificamente para fazer chamadas VoIP. Eles se conectam diretamente à rede
                                    IP e podem ter recursos avançados, como display de tela, botões programáveis e suporte a múltiplas linhas.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="4">
                                <Accordion.Header>Softphones: </Accordion.Header>
                                <Accordion.Body>
                                    São aplicativos de software que permitem fazer chamadas telefônicas diretamente de um computador ou dispositivo móvel usando
                                    uma conexão de Internet. Eles emulam as funcionalidades de um telefone físico em uma interface de software.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="5">
                                <Accordion.Header>Gateway VoIP:</Accordion.Header>
                                <Accordion.Body>
                                    É um dispositivo que conecta redes VoIP a redes telefônicas tradicionais (PSTN).
                                    Ele pode converter sinais de voz entre os formatos analógico, digital e IP, permitindo
                                    a integração de sistemas VoIP com sistemas telefônicos convencionais.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="6">
                                <Accordion.Header>PBX IP - Private Branch Exchange IP:</Accordion.Header>
                                <Accordion.Body>
                                    É um sistema de telefonia empresarial baseado em IP que roteia chamadas VoIP dentro de uma organização.
                                    Ele fornece recursos avançados, como correio de voz, menus de atendimento automático e transferência
                                    de chamadas, tudo sobre uma rede IP.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="7">
                                <Accordion.Header>SBC - (Session Border Controller) - Controlador de Borda de Sessão:</Accordion.Header>
                                <Accordion.Body>
                                    É um dispositivo usado para controlar o tráfego de mídia e sinalização em redes VoIP,
                                    protegendo contra ameaças de segurança e facilitando a interoperabilidade entre diferentes redes.

                                    Esses são alguns dos equipamentos fundamentais utilizados na infraestrutura de telefonia SIP/VoIP,
                                    cada um desempenhando um papel importante na facilitação das comunicações de voz sobre IP.
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Siglas;